import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./features/user/userSlice";
import metaSlice from "./features/meta/metaSlice";
export const store = configureStore({
  reducer: {
    user: userSlice,
    meta: metaSlice,
  },
});
